// @flow
import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components'

import { lighten, darken } from 'polished'
import hello from 'hello-color'

import colors from '../theme/colors'
import * as _colors from '../theme/_colors'
import mapProps from '../theme/mapProps'
import {
  Headline,
  ContentRow,
  ViewportRow,
  ViewportContainer,
  ViewportContent,
  PageContainer,
  Container,
  Block,
  Fill,
  Flex,
  FlexChild,
  Title,
  Text,
  Paragraph,
  ViewportRibbon
} from '../styleguide'

const ContactContainer = styled(FlexChild)`
  max-width: 32rem;
`

export default (props: any) => (
  <ContentRow>
    <Flex align="center" justify="center">
      <ContactContainer>
        <Title h="2" scale="3" my="0" width="auto">
          Contact us
        </Title>
        <Paragraph mb="3" scale="2" width="auto">
          Enim sint aliqua mollit consequat laboris qui ex. Sit sint aute aliqua velit qui esse nostrud
          laboris quis. Mollit amet veniam exercitation commodo anim laborum pariatur id velit. Cupidatat non
          fugiat ea cupidatat esse amet id ad excepteur. Ut exercitation aute ut nostrud ex in duis ut aliqua
          ullamco. Pariatur ut adipisicing Lorem pariatur ad voluptate incididunt fugiat officia amet proident
          consectetur.
        </Paragraph>
      </ContactContainer>
    </Flex>
    <ViewportRibbon/>
  </ContentRow>
)



// WEBPACK FOOTER //
// ./src/pages/contact.js